<template>
  <b-container flex>
    <div style="padding-top: 20px; padding-bottom: 10px"><span
        style="font-weight: bold; font-size: large; padding-top: 20px; padding-bottom: 10px">Nitrogen Data</span>
    </div>
    <b-row style="padding-top: 5px ">
      <b-col sm="6">Solid Fertilizer Nitrogen %:</b-col>
      <b-col sm="3"></b-col>
      <b-col sm="3" align-h="end">
        <b-form-input @change="sendUpdate" v-model="solid" min="0" max="1000" step=".10"
                      type="number" :readonly="isViewer"></b-form-input>
      </b-col>
    </b-row>
    <b-row style="padding-top:5px;">
      <b-col sm="6">Liquid Fertilizer Nitrogen %:</b-col>
      <b-col sm="3"></b-col>
      <b-col sm="3">
        <b-form-input @change="sendUpdate" v-model="liquid" min="0" max="1000" step=".10"
                      type="number" :readonly="isViewer"></b-form-input>
      </b-col>
      <b-col sm="2"></b-col>
    </b-row>
    <b-row style="padding-top:5px;">
      <b-col sm="6">Compost Nitrogen %:</b-col>
      <b-col sm="3"></b-col>
      <b-col sm="3">
        <b-form-input @change="sendUpdate" v-model="compost" min="0" max="1000" step=".10"
                      type="number" :readonly="isViewer"></b-form-input>
      </b-col>
      <b-col sm="2"></b-col>
    </b-row>
    <b-row style="padding-top:5px;">
      <b-col sm="6">Manure Nitrogen %:</b-col>
      <b-col sm="3"></b-col>
      <b-col sm="3">
        <b-form-input @change="sendUpdate" v-model="manure" min="0" max="1000" step=".10"
                      type="number" :readonly="isViewer"></b-form-input>
      </b-col>
      <b-col sm="2"></b-col>
    </b-row>
  </b-container>
</template>

<script>
import Bus from '@/eventBus';

export default {
  name: "NitrogenProduction",
  props: {year: Number, groupId: String},
  data() {
    return {
      id: '',
      myGroupId: this.groupId,
      myYear: this.year,
      solid: 0,
      liquid: 0,
      compost: 0,
      manure: 0,
      isViewer: localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('VIEWER')
    }
  },
  mounted() {
    let self = this;
    console.log("Mounting Nitrogen Control");
    this.loadNitrogenProductionData();
  },
  watch: {
    year: function (newVal, oldVal) {
      this.myYear = newVal;
    },
    groupId: function (newVal, oldVal) {
      this.myGroupId = newVal;
      this.loadNitrogenProductionData();
    }
  },
  computed:
      {},
  methods: {
    loadNitrogenProductionData: function () {
      console.log("Reloading Nitrogen Data");
      let self = this;
      this.$http.get(`metrics/production/nitrogen/vineyard/${self.myGroupId}/${self.myYear}`)
          .then(result => {
            if (result.data !== null) {
              let nitrogenData = result.data;
              self.id = nitrogenData._id;
              self.solid = nitrogenData.solid;
              self.liquid = nitrogenData.liquid;
              self.compost = nitrogenData.compost;
              self.manure = nitrogenData.manure;
            }
          })
          .catch(err => {
            this.handleError(err);
            this.$nextTick(this.sendUpdate(this.year))
          });
    },
    handleError: function (err) {
      this.$toasted.show(`Unable to retrieve Nitrogen Data: ${err.message}`,
          {
            containerClass: 'super-toasty',
            iconPack: 'fontawesome',
            closeOnSwipe: true,
            action: {
              text: 'DISMISS',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              }
            },
            icon: {
              name: 'fa-times-circle',
              after: false,
            }
          })
          .goAway(5000);
    },
    sendUpdate: function () {
      let nitrogen = {
        solid: this.solid,
        liquid: this.liquid,
        compost: this.compost,
        manure: this.manure,
        year: this.year
      };
      Bus.$emit("nitrogen-update", nitrogen);
      this.uploadNitrogenData();
    },
    uploadNitrogenData: function () {
      let self = this;
      let nitrogen = {
        solid: this.solid,
        liquid: this.liquid,
        compost: this.compost,
        manure: this.manure,
        year: this.year,
        groupId: self.groupId,
        _id: this.id
      };
      let nitrogenJson = JSON.stringify(nitrogen, null, 3);
      this.$http.post(`metrics/production/nitrogen/vineyard/${self.groupId}`, nitrogenJson
          , {
            headers: {
              'content-type': 'application/json'
            }
          }).then(response => {
        if (self.id === undefined || self.id === '') {
          self.id = response.data._id;
        }
        console.log(response);
      });
    }
  }
}
</script>

<style scoped>

</style>
